import React, { useState, useEffect } from 'react';

import CtaWidget from '~/components/CtaWidget';
import { ILearningCenterStickySignupFields } from '../../../../../types/contentful';

export function MobileStickySignup({
  header,
  subheader,
  cta
}: ILearningCenterStickySignupFields) {
  const [ctaScrollPosition, setCtaScrollPosition] = useState(false);
  const [showSignup, setShowSignup] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 400) setCtaScrollPosition(true);
      else setCtaScrollPosition(false);
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return showSignup && ctaScrollPosition ? (
    <div
      className="bg-transparent fixed bottom-10 left-0 z-[3] w-full"
      data-testid="sticky-signup"
    >
      <div className="relative content-center items-center overflow-hidden rounded-2xl bg-[#A5F3E1] px-4 py-5 shadow-md">
        <div className="column w-full flex-col !p-0">
          <h3 className="mb-2 font-glRepro text-[20px] font-medium leading-6 tracking-normal">
            {header}
          </h3>

          <p className="mb-2 font-glRepro text-[16px] font-[350] leading-6 tracking-normal">
            {subheader}
          </p>
          <div className="[&>*:first-child]:w-full [&_form]:w-full">
            <CtaWidget
              id="sticky-signup-cta"
              module="Sticky Signup"
              errorPosition="bottom"
              responsive
              {...cta?.fields}
              sysId={cta?.sys?.contentType?.sys?.id + 5}
            />
          </div>
          <button
            className="absolute right-4 top-5 inline-flex h-[24px] w-[24px] appearance-none items-center justify-center rounded-bl-popup rounded-tr-popup text-[#035C67] outline-none"
            aria-label="Close"
            data-testid="sticky-signup-close"
            onClick={() => setShowSignup(false)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M4 5L10.1188 12L4.00009 19H7.76252L12 14.1142L16.2375 19H19.9999L13.8812 12L20 5H16.2376L12 9.88595L7.76244 5H4Z"
                fill="#111212"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  ) : null;
}
